import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from 'Douleutaras/hooks/localization';

import { formatPriceParts } from './priceFormatter';
import { ServicePrice as ServicePriceData } from './types';
import './ServicePrice.scss';

interface ServicePriceProps {
  price?: ServicePriceData;
  className?: string;
}

/**
 * Renders a service's formatted price plus the `+ ΦΠΑ` ("+ VAT") subline.
 * Renders nothing when the price cannot be formatted (the row shows label-only).
 *
 * `από` and the unit sit in their own muted spans so only the amount carries the
 * emphasis, per the Figma price row states (#5685).
 */
export const ServicePrice = ({ price, className }: ServicePriceProps) => {
  const { t } = useTranslation();
  const { formatter } = useLocalization();

  const parts = formatPriceParts(price, { formatter, t });

  if (!parts) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  return (
    <span className={className} styleName="service-price">
      <span styleName="service-price__line">
        {parts.prefix && <span styleName="service-price__qualifier">{parts.prefix}</span>}
        <span styleName="service-price__amount">{parts.amount}</span>
        {parts.unitSuffix && <span styleName="service-price__qualifier">{parts.unitSuffix}</span>}
      </span>
      <span styleName="service-price__vat">{t('T.PROS-PROFILE.SERVICES.VAT-SUFFIX')}</span>
    </span>
  );
};

export default ServicePrice;
